import dsBridge from 'dsbridge/index.js'
import httpApp from '@/api/dsApp.js'

function dsCall(FunName, option = '', callBack) { // 无callBack 为同步调用 否则为异步调用
	if (!FunName) {
		return console.error('dsCall请传递方法名参数')
	}

	FunName = (httpApp[FunName] && httpApp[FunName].value) || FunName;

	if (typeof(option) !== 'string') {
		option = JSON.stringify(option);
	}
	if (option && Object.prototype.toString.call(option) === "[object Function]") { //第二个参数是否为函数,如果是函数就默认传参为''
		callBack = option;
		option = '';
	}

	if (callBack && Object.prototype.toString.call(callBack) === "[object Function]") {
		dsBridge.call(
			FunName,
			option,
			function(data) {
				try {
					var strs = JSON.parse(data);
					callBack(strs)
				} catch (e) {
					callBack(data)
				}
			}
		)
	} else {
		let dsBrDate = dsBridge.call(FunName, option);
		try {
			return JSON.parse(dsBrDate)
		} catch (e) {
			return dsBrDate
		}
	}

}

function dsRidge(FunName, option = '', type) { //FunName 方法名,option传递的参数(函数,或者是空间对象) ,type 是否为异步
	if (!FunName) {
		return console.error('dsBridge请传递方法名参数')
	}
	FunName = (httpApp[FunName] && httpApp[FunName].value) || FunName;
	if (!option && option !== '') {
		return console.error('dsRidge请传递命名空间或者处理函数')
	}
	var typeReg = type ? 'registerAsyn' : 'register'; //默认为同步 否则就是异步
	if (Object.prototype.toString.call(option) === "[object Function]") {

		dsBridge[typeReg](FunName, function(data) {
			try {
				var strs = JSON.parse(data);
				return option(strs)
			} catch (e) {
				return option(data)
			}
		})

	} else {
		let dsBrDate = dsBridge[typeReg](FunName, option);
		try {
			return JSON.parse(dsBrDate)
		} catch (e) {
			return dsBrDate
		}
	}

}

function hasNativeMethod(FunName, option = '') { //FunName 方法名,option传递的参数(函数,或者是空间对象)
	if (!FunName) {
		return console.error('dsBridge请传递方法名参数')
	}
	FunName = (httpApp[FunName] && httpApp[FunName].value) || FunName;
	if (!option && option !== '') {
		return console.error('dsRidge请传递命名空间或者处理函数')
	}
	if (Object.prototype.toString.call(option) === "[object Function]") {

		dsBridge.hasNativeMethod(FunName, function(data) {
			try {
				var strs = JSON.parse(data);
				return option(strs)
			} catch (e) {
				return option(data)
			}
		})

	} else {
		return dsBridge.hasNativeMethod(FunName)

	}

}

function dsShare(option) {
	dsBridge.call(
		'duchuang.onPageStarted',
		'{"type":"introduction_page","id":"111","url":""}'
	)
	let url = window.location.href
	dsBridge.register('duchuang', {
		tag: 'duchuang',
		returnShareInfo: () => {
			let shareData = {
				id: option.id || '',
				title: option.title || '复课必看|助力“神兽”顺利回笼',
				url: option.link || url,
				img: option.img || '',
				summary: option.summary || '家长都在转这份复课秘籍'
			}
			return JSON.stringify(shareData)
		}
	})

}



export default {
	dsCall: dsCall,
	dsRidge: dsRidge,
	dsHas: hasNativeMethod,
	dsShare: dsShare
}



// WEBPACK FOOTER //
// ./src/api/dsbridge.js